import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Toggle from 'react-toggle';
import { GEOFENCING_COMPANIES_IDS, GEOFENCING_PARTNERS_NAMES } from "../../../utils/constants";

const GreyHeader = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'components.headerNav' });
	const { title, subtitle, renderSubtitle, hideSubtitle = false, showZonePanel, setShowZonePanel } = props;
	const env = location.hostname;
	const isProd = env === 'fleet.roscolive.com';
	const company = useSelector(state => state.company.company);
	const showZonesToggle = !isProd || (isProd && (GEOFENCING_COMPANIES_IDS.includes(company.company_id) || GEOFENCING_PARTNERS_NAMES.includes(company.partner)));
	const isHomePage = location.pathname === '/';

	const onSandwichClick = () => {
		$('.sideMenu').toggleClass('menuOpenMobile')
		$('body').toggleClass('hasMobileMenu')
	}

	return (
		<header className="grey-header">
			{/* Mobile Nav */}
			<button className="mobile-nav" onClick={onSandwichClick}>
				<svg xmlns="http://www.w3.org/2000/svg" width="2.5em" height="2.5em" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
					<path fillRule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
				</svg>
			</button>

			<h1 className="page-title">{title}</h1>
			{renderSubtitle || (!hideSubtitle && <h2 className="page-subtitle">{subtitle || company.name}</h2>)}
			{isHomePage && showZonesToggle ? (
				<label className="toggle-zone-panel">
					<span>{t('labelDisplayZonePanel')}</span>
					<Toggle
						checked={showZonePanel}
						onChange={(e) => setShowZonePanel(e.target.checked)}
					/>
				</label>) : ''}
		</header>
	)
}

export default GreyHeader;
